import { actionButtonsColumnProps } from '@/components/BsrsGrid'

export function getOrganizationUnitGridButtons (deleteUnit, canDelete) {
  return actionButtonsColumnProps(x => {
    const blockDelete = x.childrenCount > 0

    const buttons = [{ url: item => `/organizational-units/${item.id}`, icon: 'pencil' }]

    if (canDelete) {
      buttons.push({
        onDelete: item => deleteUnit(item.id),
        className: blockDelete ? 'disabled' : '',
        disabled: blockDelete
      })
    }

    return buttons
  })
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/gridButtons.js